<template>
    <page-message v-if="grouped.length === saved.length">
        <template #header>{{t('result.header')}}</template>
        <template #html>
            {{t('result.message')}}
        </template>
        <template #cta>
            <router-link :to="{name:'home'}" class="btn btn-primary">{{$t('navigation.home')}}</router-link>
        </template>
    </page-message>
    <div v-else class="container">
        <div class="row">
            <div class="col-12 offset-lg-2 col-lg-8">
                <h3 class="text-center pb-3">{{t('header')}}</h3>
                <p>{{t('message')}}</p>
                <p>{{t('cta')}}</p>
                <ul>
                    <li>
                        {{t('items.1.message', grouped.length)}}

                        <div class="ms-3 mb-2 small">
                            <a v-for="(group, index) in grouped"
                               class="d-block mt-2"
                               target="_blank"
                               rel="noopener"
                               :key="index"
                               :href="group.tracking_url">
                                {{group.tracking}}
                            </a>
                        </div>
                    </li>
                    <li>
                        {{t('items.2.message')}}
                        <ul>
                            <li>{{t('items.2.items.1')}}</li>
                            <li>{{t('items.2.items.2')}}</li>
                            <li>{{t('items.2.items.3')}}</li>
                        </ul>
                    </li>
                    <li>
                        {{t('items.3.message')}}
                    </li>
                    <li>
                        {{t('items.4.message')}}
                    </li>
                </ul>
                <p>{{t('question')}}</p>
            </div>
        </div>

        <div class="d-none d-md-block">
            <div class="row font-weight-bold mt-5">
                <div class="col-4">{{t('product.name')}}</div>
                <div class="col-2 text-center">{{t('product.quantity')}}</div>
                <div class="col-2 text-center">{{t('product.tracking')}}</div>
                <div class="col-4"></div>
            </div>
        </div>

        <div v-for="(group, groupIndex) in grouped" :key="group.uuid" class="row mt-3">
            <div class="col-12 col-md-4">
                <div class="d-md-none small font-weight-bold my-3">{{t('product.name')}}</div>

                {{products_translateProductName(group.product)}}
            </div>
            <div class="col-12 col-md-2 text-md-center">
                <div class="d-md-none small font-weight-bold my-3">{{t('product.quantity')}}</div>

                {{group.product.count}}
            </div>
            <div class="col-12 col-md-2 text-md-center">
                <div class="d-md-none small font-weight-bold my-3">{{t('product.tracking')}}</div>

                <a target="_blank" rel="noopener" :href="group.tracking_url">
                    {{group.tracking}}
                </a>
            </div>
            <div class="col-12 col-md-4 my-5 my-md-0">
                <div v-if="!saved.includes(group.uuid)" class="row">
                    <div class="col-6 text-end">
                        <button type="button"
                                class="btn btn-primary btn-sm"
                                :disabled="processing[groupIndex].yes || processing[groupIndex].no"
                                @click="submit(groupIndex, 'No')">
                            <spinner v-if="processing[groupIndex].no"></spinner>
                            {{processing[groupIndex].no ? t('buttons.saving') : t('buttons.no')}}
                        </button>
                    </div>

                    <div class="col-6">
                        <button type="button"
                                class="btn btn-primary btn-sm"
                                :disabled="processing[groupIndex].yes || processing[groupIndex].no"
                                @click="submit(groupIndex,'Yes')">
                            <spinner v-if="processing[groupIndex].yes"></spinner>
                            {{processing[groupIndex].yes ? t('buttons.saving') : t('buttons.yes')}}
                        </button>
                    </div>
                </div>
                <div v-else class="text-center small">
                    {{t('result.message')}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {v4 as uuidv4} from "uuid";
    import {pick} from "lodash";

    import mixin_view from "@/mixins/view";
    import mixin_products from "@/mixins/products";
    import {retryRequest} from "@/helpers/request";

    import Panel from "@/components/Panel";
    import FormCheckbox from "@/components/form/FormCheckbox";
    import Spinner from "@/components/Spinner";
    import PageMessage from "@/components/page/PageMessage";

    export default {
        name: "ViewsSurveyDelivery",
        mixins: [mixin_view, mixin_products],
        components: {
            PageMessage,
            Spinner,
            FormCheckbox,
            Panel
        },
        data() {

            return {
                t_path: "views.survey.deliveryfaq",
                items: [],
                grouped: [],
                processing: [],
                saved: []
            }
        },
        methods: {
            submit(groupIndex, response) {

                this.processing[groupIndex][response.toLowerCase()] = true;

                const promises = this.items
                    .filter(item => this.grouped[groupIndex].references.includes(item.reference_id))
                    .map(item => retryRequest(
                            () => this.$delivery.post(
                                "/shipment-not-received-survey",
                                {response, item: pick(item, "_id", "order_id")}
                            )
                        )
                    )

                return Promise
                    .all(promises)
                    .then(() => this.saved.push(this.grouped[groupIndex].uuid))
                    .catch(error => this.base_error(error))
                    .finally(() => this.processing[groupIndex][response.toLowerCase()] = false);
            },
            fetch() {

                // get items that were not received "src/views/survey/ViewsSurveyDelivery.vue" here
                const references = this.$route.query.reference_ids.split(",");

                // leave only not received items
                this.items = this.$session
                    .get(this.$route.query.itemsReference, [])
                    .filter(item => references.includes(item.reference_id));

                // Group items by order id, tracking and product sku
                this.grouped = this.items.reduce(
                    (result, item) => {

                        // check for we already have a group with this product and tracking
                        const index = result.findIndex(resultItem =>
                            resultItem.order_id === item.order_id &&
                            resultItem.tracking === item.tracking &&
                            resultItem.sku === item.sku
                        );

                        if (-1 !== index) {

                            result[index].references.push(item.reference_id);
                            result[index].product.count++;
                        } else {

                            result.push({
                                uuid: uuidv4(),
                                order_id: item.order_id,
                                tracking: item.tracking,
                                tracking_url: item.tracking_url,
                                sku: item.sku,
                                references: [item.reference_id],
                                product: {
                                    count: 1,
                                    ...pick(item, ["_id", "order_id", "name", "generic_name", "lang_overrides"])
                                }
                            })
                        }

                        return result;
                    },
                    []
                );

                // Prepare processing array
                this.grouped.forEach(group => this.processing.push({yes: false, no: false}));
            }
        },
        mounted() {

            this.fetch();
        }
    }
</script>